<div class="checkbox-container">
  <i *ngIf="type === 'box'" [ngClass]="'icon icon-pin-' + pinColor"></i>
  <span class="label">{{ label }}</span>
  <div class="option" (click)="onClick()">
    <div class="checker {{ type }}" [ngClass]="{ checked: checked }">
      <div class="check"></div>
    </div>
  </div>
</div>
